export default {
    showVariationsModal: {
        copy: 'Copy',
        contentVariation: 'Content variation',
        chosenContent: 'Chosen content',
        chosenContentPlaceholder: 'Please input',
        continue: 'Continue',
        generateNewContent: 'Generate new content',
        type: 'Type:',
        contentTitle: 'Title:',
        descriptionLabel: 'Description:',
        keywordsLabel: 'Keywords:',
        writingTone: 'Writing tone:',
        context: 'Context:',
        cancel: 'Cancel',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
